module.exports = __webpack_public_path__ + "b2281f4c1da2482b8b4cea67fd0739db.MP3";